import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { APP_LINKS } from '@/helpers/links';
import IconCalculator from '@scramble/design-system/icons/calculator.svg';
import { useIsMobile } from '@scramble/hooks';
import { Button, MyTooltip } from '@scramble/ui';
import s from './index.module.scss';

export const CalculatorLink = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onClick = () => {
    navigate(APP_LINKS.calculator)
  }

  return (
    <MyTooltip
      theme="dark"
      renderElement={() =>
        isMobile ? (
          <Button
            theme="neutral"
            appearance="tonal"
            size="md"
            onClick={onClick}
            className={s.calculator}
          >
            <img src={IconCalculator} alt="calculator" width={20} height={20} />
            <span>Investment calculator</span>
          </Button>
        ) : (
          <Button
            iconUrl={IconCalculator}
            theme="neutral"
            appearance="tonal"
            size="md"
            onClick={onClick}
          />
        )
      }
      renderContent={() => (
        <span className="f-body-sm">{t('calculator:tooltip_link')}</span>
      )}
    />
  );
};